import { SOCIAL_AD_TYPES } from "utils/constants";

import FacebookImage from "social/formats/FacebookImage/FacebookImage";
import FacebookVideo from "social/formats/FacebookVideo/FacebookVideo";
import FacebookCarousel from "social/formats/FacebookCarousel";

import GoogleDemandGenImage from "social/formats/GoogleDemandGenImage";

import FacebookImageMO from "social/formats/FacebookImageMO/FacebookImageMO";
import FacebookVideoMO from "social/formats/FacebookVideoMO/FacebookVideoMO";
import FacebookCarouselMO from "social/formats/FacebookCarouselMO";

import GoogleDemandGenCarousel from "social/formats/GoogleDemandGenCarousel";

import LinkedInImage from "social/formats/LinkedInImage";
import LinkedInVideo from "social/formats/LinkedInVideo";
import LinkedInCarousel from "social/formats/LinkedInCarousel";

import PinterestImage from "social/formats/PinterestImage";
import PinterestVideo from "social/formats/PinterestVideo";
import PinterestMaxWidthVideo from "social/formats/PinterestMaxWidthVideo";
import PinterestCarousel from "social/formats/PinterestCarousel";

import SnapchatImage from "social/formats/SnapchatImage";
import SnapchatVideo from "social/formats/SnapchatVideo";
import SnapchatCommercial from "social/formats/SnapchatCommercial";
import SnapchatStoryCarousel from "social/formats/SnapchatStoryCarousel";

import TwitterImage from "social/formats/TwitterImage";
import TwitterVideo from "social/formats/TwitterVideo";

import YouTubeInStream from "social/formats/YouTubeInStream";
import YouTubeDiscovery from "social/formats/YouTubeDiscovery";

import TikTokVideo from "social/formats/TikTokVideo";

import RedditImage from "social/formats/RedditImage";
import RedditVideo from "social/formats/RedditVideo";

export const FORM_BY_ADTYPE = {
	[SOCIAL_AD_TYPES.FACEBOOK_IMAGE]: FacebookImage,
	[SOCIAL_AD_TYPES.FACEBOOK_VIDEO]: FacebookVideo,
	[SOCIAL_AD_TYPES.FACEBOOK_CAROUSEL]: FacebookCarousel,
	[SOCIAL_AD_TYPES.FACEBOOK_IMAGE_MO]: FacebookImageMO,
	[SOCIAL_AD_TYPES.FACEBOOK_VIDEO_MO]: FacebookVideoMO,
	[SOCIAL_AD_TYPES.FACEBOOK_CAROUSEL_MO]: FacebookCarouselMO,

	[SOCIAL_AD_TYPES.GOOGLE_DEMAND_GEN_IMAGE]: GoogleDemandGenImage,
	[SOCIAL_AD_TYPES.GOOGLE_DEMAND_GEN_CAROUSEL]: GoogleDemandGenCarousel,

	[SOCIAL_AD_TYPES.LINKEDIN_IMAGE]: LinkedInImage,
	[SOCIAL_AD_TYPES.LINKEDIN_VIDEO]: LinkedInVideo,
	[SOCIAL_AD_TYPES.LINKEDIN_CAROUSEL]: LinkedInCarousel,

	[SOCIAL_AD_TYPES.PINTEREST_IMAGE]: PinterestImage,
	[SOCIAL_AD_TYPES.PINTEREST_VIDEO]: PinterestVideo,
	[SOCIAL_AD_TYPES.PINTEREST_MAX_WIDTH_VIDEO]: PinterestMaxWidthVideo,
	[SOCIAL_AD_TYPES.PINTEREST_CAROUSEL]: PinterestCarousel,

	[SOCIAL_AD_TYPES.SNAPCHAT_IMAGE]: SnapchatImage,
	[SOCIAL_AD_TYPES.SNAPCHAT_VIDEO]: SnapchatVideo,
	[SOCIAL_AD_TYPES.SNAPCHAT_COMMERCIAL]: SnapchatCommercial,
	[SOCIAL_AD_TYPES.SNAPCHAT_CAROUSEL]: SnapchatStoryCarousel,

	[SOCIAL_AD_TYPES.TWITTER_IMAGE]: TwitterImage,
	[SOCIAL_AD_TYPES.TWITTER_VIDEO]: TwitterVideo,

	[SOCIAL_AD_TYPES.YOUTUBE_INSTREAM]: YouTubeInStream,
	[SOCIAL_AD_TYPES.YOUTUBE_DISCOVERY]: YouTubeDiscovery,

	[SOCIAL_AD_TYPES.TIKTOK_VIDEO]: TikTokVideo,

	[SOCIAL_AD_TYPES.REDDIT_IMAGE]: RedditImage,
	[SOCIAL_AD_TYPES.REDDIT_VIDEO]: RedditVideo,
};
